import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SendIcon from '@mui/icons-material/Send';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VisibilityIcon from "@mui/icons-material/Visibility";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { AddButton } from "../../../utils/Custom/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { AutoCompletes } from "../../../utils/Custom/custominput";
import { handleApproval } from "../inspection/inspectionUtils";
import { Autocomplete, TextField, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { statesList } from "../../constants/stateList";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import ViewFileModalInspectionList from "./viewFileModalInspectionList";
import { toast } from "react-toastify";
import { clienTypes } from "../../../utils/commonComponent/common";
import moment from "moment";
import { notifiy } from "../../notification/Notification";
import { formateDate, paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";
import { getPermissions } from "../rbac/hasAccess";
import { textTruncate } from "../../../utils/commonComponent/truncate";

const headers = ["id", "Client", "address", "reportNo", "poNumber", "jobNumber", "inspectionLocation", "inspectionStartDate", "inspectionEndDate", "inspectionNumber", "Items",          // instead of "subcategory""state","empName",
];

const fields = [
  { value: "Client", label: "Client" },
  { value: "jobNumber", label: "Job No" },
  { value: "inspectionNumber", label: "Inspection No" },
  { value: "reportNo", label: "Report No" },
  { value: "empName", label: "Employee Name" },
];

const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const normalize = (str) => (str || "").toString().trim().toLowerCase();

const findDistrict = (stateName, cityName) => {
  const normState = normalize(stateName);
  const normCity = normalize(cityName);
  if (!normState || !normCity) return null;

  const matchedState = statesList.find((s) => normalize(s.label) === normState);
  if (!matchedState) return null;

  return matchedState.district?.find((d) => normalize(d.city) === normCity) || null;
};

const InspectionTaskList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);

  const handleEdit = (row) => {
    if (row?.approvedBy) {
      alert(`This Report No: ${row.reportNo} are approved.\n\nTo change/update these report details, please withdraw the report.`);
      return; // stop navigation
    }
    // Navigate if not approved
    navigate(`/inspectionReport/${row.id}`);
  };

  const [InspectionTaskList, setInspectionTaskList] = React.useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const [selectedOuterID, setSelectedOuterID] = React.useState(false);
  const [selectedApproveIds, setselectedApproveIds] = React.useState([]);

  const [jobNumberList, setjobNumberList] = React.useState([]);
  const [selectedJobId, setSelectedJobId] = React.useState(null);
  const [relatedInspections, setRelatedInspections] = React.useState([]);

  const [fromInspection, setFromInspection] = React.useState(null);
  const [toInspection, setToInspection] = React.useState(null);
  const [filteredInspectionIds, setFilteredInspectionIds] = React.useState([]);
  const [empList, setEmpList] = React.useState([]);
  const [sortInpectorList, setSortinpectorList] = React.useState([]);
  const [selectedEmp, setSelectedEmp] = React.useState(null);
  const [selectClientID, setselectClientID] = React.useState(null);

  const userType = localStorage.getItem("type") || "";
  const userID = localStorage.getItem("id") || "";
  const hasRole = ["2"].some(role => (localStorage.getItem("roles") || "").split(",").includes(role)) || userType == 1 || userType == 5;

  const [openModal, setOpenModal] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const [modalType, setModalType] = React.useState("documents");

  const [selectedIds, setSelectedIds] = React.useState([]);

  // Menu states
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const handleViewModal = (row, type = "documents") => {
    setModalData(row);
    setOpenModal(true);
    setModalType(type);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalData(null);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
    setselectedApproveIds(updated);
  };

  const handleSelectAll = () => {
    const validIds = InspectionTaskList
      .filter(row => !row.approvedBy)
      .map(row => row.id);

    if (selectedIds.length === validIds.length && validIds.length > 0) {
      setSelectedIds([]);
      setselectedApproveIds([]);
    } else {
      setSelectedIds(validIds);
      setselectedApproveIds(validIds);
    }
  };

  // Fixed: Calculate isAllSelected based on valid selectable rows only
  const validSelectableRows = InspectionTaskList.filter(row => !row.approvedBy);
  const isAllSelected = validSelectableRows.length > 0 && selectedIds.length === validSelectableRows.length;

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      Client: "c.companyName",
      jobNumber: "jr.jobNumber",
      inspectionNumber: "jri.inspectionNumber",
      poNumber: "jr.poNumber",
      reportNo: "ir.reportNo",
      empName: "emp.name",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }
    if (userType == 2) {
      whereConditions += whereConditions ? ` AND jri.assigneuserID = ${userID} AND ir.approvedBy IS NULL` : `WHERE jri.assigneuserID = ${userID} AND ir.approvedBy IS NULL`;
    }

    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT jri.id AS id, jri.assigneuserID, jri.jobRegisterId, jri.servicesNameId, ii.subcategory, jri.inspectionNumber, jri.status, jri.clientRequestFile, jri.qapDrawings,jri.technicalDatasheet,jri.technicalSpecification,jr.state,jr.inspectionLocation, jr.jobNumber, jr.poNumber, jr.inspectionStartDate, jr.inspectionEndDate, c.id AS client_id, c.type as clientType, c.companyName as Client,ir.requestApproval,ir.rejectedBy,ir.approvedBy,ir.reportNo, addr.address AS address, emp.name AS empName FROM jobRegisterInspection jri LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients c ON jr.clientId = c.id LEFT JOIN addresses addr ON jr.address = addr.id LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id LEFT JOIN IR ir ON jri.id = ir.jobRegisterInspectionId LEFT JOIN users u ON jri.assigneuserID = u.id LEFT JOIN employees emp ON u.employeeId = emp.id ${whereClause} ORDER BY jri.id DESC ${paginationSettings};`;
  }

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM jobRegisterInspection jri LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients c ON jr.clientId = c.id LEFT JOIN addresses addr ON jr.address = addr.id LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id LEFT JOIN IR ir ON jri.id = ir.jobRegisterInspectionId LEFT JOIN users u ON jri.assigneuserID = u.id LEFT JOIN employees emp ON u.employeeId = emp.id ${whereClause};`;
  }

  const fetchData = async () => {
    try {
      const [inspectionTaskList, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      let modifiedData = inspectionTaskList?.map((item) => {
        return {
          ...item,
          Items: item.subcategory || "",
          Client: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),
        };
      });
      setInspectionTaskList(modifiedData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchAllJobs = async () => {
    try {
      const jobList = await fetchQuery("SELECT * FROM jobRegister order by id desc");
      const jobNumberListFormatted = jobList.map((job) => ({
        value: job.id,
        label: job.jobNumber,
        clientId: job.clientId,
        state: job.state,
        location: job.location,
      }));

      setjobNumberList(jobNumberListFormatted);
    } catch (error) {
      console.error("Error fetching all jobRegister:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const fetchRelatedInspections = async () => {
    if (!selectedJobId) return;
    const query = `SELECT * FROM jobRegisterInspection WHERE jobRegisterId = ${selectedJobId} ORDER BY id ASC`;
    const res = await fetchQuery(query);
    setRelatedInspections(res);
  };

  const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371; // Radius of the Earth in km

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const fetchClientsbyid = async () => {
    if (!selectedJobId) return;

    // const query = `SELECT * FROM clients WHERE id = ${selectClientID}`;
    // const res = await fetchquery(query);
    const res = jobNumberList.find((job) => job.value === selectedJobId);
    const jobclient = res;
    if (!jobclient) return;

    const jobclientState = jobclient.state?.trim();
    const jobclientDistrict = jobclient.location?.trim();
    // console.log({jobclientState, jobclientDistrict})
    // Step 1: Find the job's district (any state)
    const matchedDistrict = findDistrict(jobclientState, jobclientDistrict);
    // Step 2: Find the full district object
    if (!matchedDistrict) {
      console.warn("Job State or District not matched.");
      return;
    }
    // Step 3: Map employees with distance, regardless of whether inspector is in the same state
    const locationWiseFilterEmployee = empList.map((insp) => {
      const districtObj = findDistrict(insp.state, insp.location);
      if (districtObj) {
        const distance = haversineDistance(
          parseFloat(matchedDistrict.lat),
          parseFloat(matchedDistrict.lng),
          parseFloat(districtObj.lat),
          parseFloat(districtObj.lng)
        );
        return { ...insp, distance };
      }
      return { ...insp, distance: null };
    });
    // Step 4: Sort
    locationWiseFilterEmployee.sort((a, b) => {
      // Prioritize those with a valid distance (same state)
      if (a.distance !== null && b.distance === null) return -1;
      if (a.distance === null && b.distance !== null) return 1;

      // If both are valid, sort by distance
      if (a.distance !== null && b.distance !== null) {
        return a.distance - b.distance;
      }
      // Otherwise keep original order
      return 0;
    });
    // Step 5: Log results
    // console.log("Sorted employees by Proximity:");
    locationWiseFilterEmployee.forEach((insp) => {
      const dist = insp.distance !== null ? `${insp.distance.toFixed(2)} km` : "N/A";
      console.log(`${insp.name} (${insp.location}) - ${dist}`);
    });

    setSortinpectorList(locationWiseFilterEmployee);
  };

  const fetchEmployeeList = async () => {
    const query = `SELECT u.*, emp.name, emp.state, emp.location FROM users u LEFT JOIN employees emp ON u.employeeId = emp.id WHERE u.status = 1 AND u.type = 2 ORDER BY u.id DESC`;
    const res = await fetchQuery(query);
    setEmpList(res);
  };

  const updateInspectionStatus = async (ids) => {
    const confirmAction = window.confirm(
      "Are you sure you want to send for approval?"
    );

    if (!confirmAction) return;
    try {
      const normalizedIds = Array.isArray(ids) ? ids : [ids];
      const query = `update IR SET requestApproval = 2 WHERE id IN  (${normalizedIds.join(",")})`;
      await fetchQuery(query);
      toast.success("Sent for approval successfully!");
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error("Failed to update inspection status:", error);
    }
  };

  // Add these states near your other states (around line 48)
  const [withdrawalDialogOpen, setWithdrawalDialogOpen] = React.useState(false);
  const [withdrawalReason, setWithdrawalReason] = React.useState("");
  const [withdrawalId, setWithdrawalId] = React.useState(null);
  const [withdrawalRowData, setWithdrawalRowData] = React.useState(null);

  // Add this new function to handle the actual withdrawal
  const handleConfirmWithdrawal = async () => {
    try {
      const normalizedIds = Array.isArray(withdrawalId) ? withdrawalId : [withdrawalId];
      const query = `UPDATE IR SET requestApproval = 1, approvedBy = NULL, rejectedBy = NULL WHERE id IN (${normalizedIds.join(",")})`;
      await fetchQuery(query);

      // Get inspection numbers and test names for notification
      const getSelectedInspectionNumbers = () => {
        return InspectionTaskList
          .filter(i => normalizedIds.includes(i.id))
          .map(i => i.inspectionNumber)
          .join(", ");
      };

      const getSelectedTestNames = () => {
        const tests = InspectionTaskList
          .filter(i => normalizedIds.includes(i.id))
          .map(i => i.Items)
          .filter(Boolean);
        return [...new Set(tests)].join(", ");
      };

      const inspectionNumbers = getSelectedInspectionNumbers();
      const testNames = getSelectedTestNames();

      // Send notification to userID
      const empIdToNotify = withdrawalRowData?.userID;

      if (empIdToNotify) {
        const notification = {
          _from: userID,
          _to: empIdToNotify,
          body: `Inspection Report Approval Withdrawn
Report No       : ${withdrawalRowData?.reportNo || ""}
Job No       : ${withdrawalRowData?.jobNumber || ""}
Inspection No: ${inspectionNumbers}
Test Name    : ${testNames}
Reason       : ${withdrawalReason}`,
          datasheetIds: normalizedIds.join(","),
          type: 1,
        };
        setTimeout(() => {
          notifiy(notification, () => {
            console.log(`Notification sent for withdrawal`);
          });
        }, 100);
      }
      toast.success("Withdrawn successfully!");
      // Reset states
      setWithdrawalDialogOpen(false);
      setWithdrawalReason("");
      setWithdrawalId(null);
      setWithdrawalRowData(null);
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error("Failed to withdraw:", error);
      toast.error("Failed to withdraw approval");
    }
  };

  // Add this function to handle dialog close
  const handleCloseWithdrawalDialog = () => {
    setWithdrawalDialogOpen(false);
    setWithdrawalReason("");
    setWithdrawalId(null);
    setWithdrawalRowData(null);
  };

  const jobWithdrawApproval = async (id, rowData) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to withdraw the approval?"
    );
    if (!isConfirmed) return;
    // Open dialog instead of direct confirmation
    setWithdrawalId(id);
    setWithdrawalRowData(rowData);
    setWithdrawalDialogOpen(true);
  };

  // const jobWithdrawApproval = async (ids) => {
  //   const isConfirmed = window.confirm(
  //     "Are you sure you want to withdraw the approval?"
  //   );
  //   if (!isConfirmed) return;
  //   try {
  //     const normalizedIds = Array.isArray(ids) ? ids : [ids];
  //     const query = `update IR SET requestApproval = 1, approvedBy = NULL, rejectedBy = NULL WHERE id IN  (${normalizedIds.join(",")})`;
  //     await fetchquery(query);
  //     toast.success("Withdraw successfully!");
  //     setTimeout(() => window.location.reload(), 500);
  //   } catch (error) {
  //     console.error("Failed to update withdraw:", error);
  //   }
  // };

  const jobAssignEmployee = async (selectedEmpId) => {
    setSelectedEmp(selectedEmpId);
    if (filteredInspectionIds.length === 0) {
      alert("Please select an employee and a valid inspection range.");
      return;
    }
    const getSelectedInspectionNumbers = () => {
      return relatedInspections
        .filter(i => filteredInspectionIds.includes(i.id))
        .map(i => i.inspectionNumber).join(", ");
    };
    const getSelectedTestNames = () => {
      const tests = InspectionTaskList
        .filter(i => filteredInspectionIds.includes(i.id))
        .map(i => i.Items).filter(Boolean);
      return [...new Set(tests)].join(", ");
    };

    const inspectionNumbers = getSelectedInspectionNumbers();
    const testNames = getSelectedTestNames();

    const selectedId = selectedEmpId == 0 ? null : selectedEmpId;
    const idsToUpdate = filteredInspectionIds.join(",");
    try {
      const query = `UPDATE jobRegisterInspection SET assigneuserID = ${selectedId} WHERE id IN (${idsToUpdate})`;
      await fetchQuery(query);
      const notification = {
        _from: userID,
        _to: selectedId,
        body: `Job Assigned
        Job ID       : ${jobNumberList.find((job) => job.value === selectedJobId)?.label || ""}
        Inspection No: ${inspectionNumbers}
        Test Name    : ${testNames}`,
        datasheetIds: filteredInspectionIds.join(","),
        type: 1,
      };
      setTimeout(() => {
        notifiy(notification, () => {
          console.log(`Notified of assigned jobs`);
        })
      }, 100);
      toast.success("Job assigned successfully!");
      setTimeout(() => window.location.reload(), 500);
    } catch (err) {
      console.error("Failed to assign employees:", err);
    }
  };

  useEffect(() => {
    if (fromInspection && toInspection) {
      const fromIndex = relatedInspections.findIndex(
        (i) => i.id === fromInspection
      );
      const toIndex = relatedInspections.findIndex(
        (i) => i.id === toInspection
      );

      if (fromIndex !== -1 && toIndex !== -1) {
        const [start, end] =
          fromIndex <= toIndex ? [fromIndex, toIndex] : [toIndex, fromIndex];

        const filteredIds = relatedInspections
          .slice(start, end + 1)
          .map((i) => i.id);

        setFilteredInspectionIds(filteredIds);
      }
    } else {
      setFilteredInspectionIds([]);
    }
  }, [fromInspection, toInspection, relatedInspections]);

  useEffect(() => {
    fetchRelatedInspections();
    fetchClientsbyid();
  }, [selectedJobId]);

  useEffect(() => {
    fetchData();
  }, [empList, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchEmployeeList();
  }, []);

  useEffect(() => {
    if (selectedOuterID) {
      fetchAllJobs();
    }
  }, [selectedOuterID]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {/* <AddButton
        id="btn-add-outline"
        to="/editJobRegister/0"
        label="Add Job Register"
        icon={<AddIcon fontSize="small" />}
      /> */}

      <ListSearchSection
        title="Search Inspection"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />
      <div className="flex space-x-10 my-5">
        {(userType == 1 || userType == 4 || userType == 5) && (
          <>
            <AddButton
              id="btn-add-outline"
              label="Assign Job"
              onClick={() => setSelectedOuterID(!selectedOuterID)}
            />
          </>
        )}
        {/* {hasRole && selectedApproveIds.length > 0 && (
        <>
        <AddButton
          id="btn-add-outline"
          label="Approve"
          onClick={() => handleApproval(selectedApproveIds)}
        />
      </>
      )} */}
      </div>
      {selectedOuterID && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2 my-3">
          <Autocomplete
            id="search-field"
            size={"small"}
            options={jobNumberList}
            getOptionLabel={(option) => option.label}
            value={jobNumberList.find((job) => job.value === selectedJobId) || null}
            onChange={(event, value) => {
              setSelectedJobId(value ? value.value : null);
              const selectedJob = jobNumberList.find((job) => job.value === value?.value);
              if (selectedJob) {
                setselectClientID(selectedJob.clientId);
              }
            }}
            renderInput={(params) => <TextField {...params} label="Select Job" />}
          />

          {relatedInspections.length > 0 && (
            <>
              <AutoCompletes
                id="from-inspection"
                label="From Inspection"
                options={[...relatedInspections]
                  .sort((a, b) =>
                    a.inspectionNumber.localeCompare(b.inspectionNumber)
                  )
                  .map((i) => ({
                    label: i.inspectionNumber,
                    value: i.id,
                  }))}
                value={fromInspection}
                onChange={(val) => setFromInspection(val)}
              />

              <AutoCompletes
                id="to-inspection"
                label="To Inspection"
                options={[...relatedInspections]
                  .sort((a, b) =>
                    b.inspectionNumber.localeCompare(a.inspectionNumber)
                  )
                  .map((i) => ({
                    label: i.inspectionNumber,
                    value: i.id,
                  }))}
                value={toInspection}
                onChange={(val) => setToInspection(val)}
              />

              <Autocomplete
                id="search-field"
                options={[
                  { label: "Withdraw Job", value: null }, // <-- first option
                  ...sortInpectorList.map(i => ({
                    label: `${i.name} (${i.userName})${i.distance !== null ? ` - ${i.distance.toFixed(2)} km` : ""
                      }`,
                    value: i.id,
                    name: i.name,
                    userName: i.userName,
                    distance: i.distance,
                  })),
                ]}
                value={selectedEmp
                  ? sortInpectorList.find(i => i.id === selectedEmp)
                  : null}
                onChange={(e, v) => jobAssignEmployee(v?.value || null)}
                getOptionLabel={option => option?.label || ""}
                filterOptions={(options, { inputValue }) => {
                  const lower = inputValue.toLowerCase();
                  return options.filter(option =>
                    option.label === "Withdraw Job" ||
                    option.name?.toLowerCase().includes(lower) ||
                    option.userName?.toLowerCase().includes(lower)
                  );
                }}
                renderOption={(props, option) => (
                  <li {...props} style={{ color: option.label === "Withdraw Job" ? "red" : "inherit" }}>
                    {option.label}
                  </li>
                )}
                renderInput={p => <TextField {...p} label="Select Employee" size="small" />}
              />
            </>
          )}
        </div>
      )}

      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[550px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                {/* {hasRole && (
                  <th className="px-2 py-3 text-center">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  </th>
                )} */}
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Client</th>
                <th className="px-4 py-3 whitespace-nowrap">Address</th>
                <th className="px-4 py-3 whitespace-nowrap">Report No</th>
                {userType != 2 && <th className="px-4 py-3 whitespace-nowrap">PO Number</th>}
                {userType != 2 && <th className="px-4 py-3 whitespace-nowrap">Job Number</th>}
                <th className="px-4 py-3 whitespace-nowrap">Inspection Location</th>
                <th className="px-4 py-3 whitespace-nowrap">Start Date</th>
                <th className="px-4 py-3 whitespace-nowrap">End Date</th>
                {userType != 2 && <th className="px-4 py-3 whitespace-nowrap">Inspection No</th>}
                <th className="px-4 py-3 whitespace-nowrap">Items</th>
                <th className="px-4 py-3 whitespace-nowrap">State</th>
                <th className="px-4 py-3 whitespace-nowrap">Inspector</th>
                {(permissions.view || permissions.edit || permissions.allAccess) && <th className="px-4 py-3 whitespace-nowrap">Actions</th>}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {InspectionTaskList?.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {/* {hasRole && (
                    <td className="px-2 py-2 text-center">
                      <input
                        type="checkbox"
                        disabled={!!row.approvedBy}
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleSelectRow(row.id)}
                      />
                    </td>
                  )} */}
                  <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}</td>
                  <td className="px-4 py-3 cursor-pointer hover:text-blue-600"
                    onClick={() => handleEdit(row)}
                  >{textTruncate(row.Client) ?? "-"}</td>
                  <td className="px-4 py-3">{textTruncate(row.address) ?? "-"}</td>
                  <td
                    className={`px-4 py-3 cursor-pointer hover:text-blue-600 ${row.rejectedBy
                      ? "bg-[#FF3F33]"
                      : row.approvedBy
                        ? "bg-[#b0b0fa]"
                        : row.requestApproval === 2
                          ? "bg-red-200"
                          : !row.approvedBy
                            ? "bg-[#b5ebe3]"
                            : ""
                      }`}
                    onClick={() => handleEdit(row)}
                  >
                    {row.reportNo ?? "-"}
                  </td>
                  {userType != 2 && (
                    <td className="px-4 py-3">{row.poNumber ?? "-"}</td>
                  )}
                  {userType != 2 && (
                    <td className="px-4 py-3 cursor-pointer hover:text-blue-600" onClick={() => handleEdit(row)}>{row.jobNumber ?? "-"}</td>
                  )}
                  <td className="px-4 py-3">{textTruncate(row.inspectionLocation) ?? "-"}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{formateDate(row.inspectionStartDate)}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{formateDate(row.inspectionEndDate)}</td>
                  {userType != 2 && (
                    <td
                      className="px-4 py-3 cursor-pointer hover:text-blue-600"
                      onClick={() => handleEdit(row)}
                    >
                      {row.inspectionNumber ?? "-"}
                    </td>
                  )}
                  <td className="px-4 py-3">{textTruncate(row.Items) ?? "-"}</td>
                  <td className="px-4 py-3">{row.state ?? "-"}</td>
                  <td className="px-4 py-3">{row.empName ?? "-"}</td>
                  <td className="px-4 py-2 text-center whitespace-nowrap">
                    <div className="flex items-center justify-center gap-2">
                      {(permissions.edit || permissions.allAccess) && (
                        <button
                          onClick={() => handleEdit(row)}
                          className="text-blue-600"
                        >
                          <EditIcon fontSize="small" />
                        </button>
                      )}
                      {userType == 2 && (
                        <button
                          onClick={() => updateInspectionStatus(row.id)}
                          disabled={row.requestApproval == 2}
                          className={`text-blue-600 disabled:text-gray-400`}
                        >
                          <Tooltip title="Send For Approval" arrow>
                            <SendIcon fontSize="small" />
                          </Tooltip>
                        </button>
                      )}
                      {hasRole && (
                        <button
                          onClick={() => jobWithdrawApproval(row.id, row)}
                          disabled={!row.approvedBy}
                          className={`text-blue-600 disabled:text-gray-400`}
                        >
                          <Tooltip title="Widhraw Approval" arrow>
                            <RunningWithErrorsIcon fontSize="small" />
                          </Tooltip>
                        </button>
                      )}
                      {(permissions.pdfDownload || permissions.viewDocument || permissions.allAccess) && (
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, row)}
                        className="text-blue-600"
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                      )}
                      <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl && menuRow === row)}
                        onClose={handleMenuClose}
                      >
                        {(permissions.pdfDownload || permissions.allAccess) && (
                          <MenuItem
                            onClick={() => {
                              handleMenuClose();
                              navigate(`/viewIRReport/${menuRow.id}`);
                            }}
                          >
                            <PictureAsPdfIcon
                              fontSize="small"
                              className="text-blue-600 mr-2"
                            />
                            Pdf
                          </MenuItem>
                        )}
                        {(permissions.viewDocument || permissions.allAccess) && (
                          <MenuItem
                            onClick={() => {
                              handleMenuClose();
                              handleViewModal(menuRow, "documents");
                            }}
                          >
                            <VisibilityIcon
                              fontSize="small"
                              className="text-blue-600 mr-2"
                            />
                            View Documents
                          </MenuItem>
                        )}
                        {(permissions.viewDocument || permissions.allAccess) && (
                          <MenuItem
                            onClick={() => {
                              handleMenuClose();
                              handleViewModal(menuRow, "attachments");
                            }}
                          >
                            <AttachFileIcon
                              fontSize="small"
                              className="text-blue-600 mr-2"
                            />
                            View Attachments
                          </MenuItem>
                        )}
                      </Menu>
                    </div>
                  </td>
                </tr>
              ))}
              {InspectionTaskList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + (hasRole ? 2 : 1)}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handlePaginationChange(0, Number(e.target.value))}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRows
                )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage - 1, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage + 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(Math.ceil(totalRows / rowsPerPage) - 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>

      {/* Withdrawal Reason Dialog */}
      <Dialog open={withdrawalDialogOpen}
        onClose={handleCloseWithdrawalDialog}
        maxWidth="sm" fullWidth
      >
        <DialogTitle>Withdraw Approval</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Please provide a reason for withdrawing the approval:
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for Withdrawal"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={withdrawalReason}
            onChange={(e) => setWithdrawalReason(e.target.value)}
            placeholder="Enter the reason for withdrawal..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseWithdrawalDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmWithdrawal}
            variant="contained"
            color="error"
            disabled={!withdrawalReason.trim()}
          >
            Confirm Withdrawal
          </Button>
        </DialogActions>
      </Dialog>

      {/* file modal */}
      <ViewFileModalInspectionList openModal={openModal} modalData={modalData} handleCloseModal={handleCloseModal} modalType={modalType} />
    </>
  );
};

export default InspectionTaskList;